import { CommunityDiscussComments } from "../../community/models/CommunityDiscussComments";
import { CommentsGroup } from "../../community/utils/CommentsGroup";
import { GroupDate } from "../../community/utils/DateTransform";
import { CommunityAdminComment } from "./CommunityAdminComment";

type Props = {
    comments: CommunityDiscussComments[];
    onDeleteComment: (comment: CommunityDiscussComments) => void;
    onSuspendUser: (comment: CommunityDiscussComments) => void;
}

export const CommunityAdminCommentsWrap = ({ comments, onDeleteComment, onSuspendUser }: Props) => {
    if(comments.length <= 0)
        return <></>
    
    const _commentsByDate = CommentsGroup(comments);
    return (
        <>
        {Object.keys(_commentsByDate).map((date, i) => (
            <>
                <div className="community-separator" key={`${date}_${i}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="372" height="1" viewBox="0 0 372 1" fill="none">
                        <path d="M0 0.5H372" stroke="#E9E9E9"/>
                    </svg>
                    <span style={{ whiteSpace: "nowrap" }}>
                        {GroupDate(date)}
                    </span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="372" height="1" viewBox="0 0 372 1" fill="none">
                        <path d="M0 0.5H372" stroke="#E9E9E9"/>
                    </svg>
                </div>
                {
                    _commentsByDate[date].map((c, i) => (
                        <CommunityAdminComment 
                            key={`${i}_${c.id}`}
                            comment={c}
                            onDeleteComment={() => onDeleteComment(c)}
                            onSuspendUser={() => onSuspendUser(c)} 
                        />
                    ))
                }
            </>
        ))}
        </>
    )
}